export default __webpack_public_path__ + "static/media/bonus2.935a5fa5.png";